import { GA_EVENT_NAME, GuestCampaignDisplayType } from '@/constants/ga';
import { AdParams } from '@/utils/ad';

/**
 * UI言語切り替え GAイベントを送信
 */
export const sendChangeUiLangEvent = (value: { ui_lang: string }) => {
  window.gtag('event', GA_EVENT_NAME.CHANGE_UI_LANG, value);
};

/**
 * 翻訳元言語切り替え GAイベントを送信
 */
export const sendChangeSrcLangEvent = (value: { src_lang: string }) => {
  window.gtag('event', GA_EVENT_NAME.CHANGE_SRC_LANG, value);
};

/**
 * 翻訳先言語切り替え GAイベントを送信
 */
export const sendChangeDestLangEvent = (value: { dest_lang: string }) => {
  window.gtag('event', GA_EVENT_NAME.CHANGE_DEST_LANG, value);
};

/**
 * ゲスト画面キャンペーンポップアップ GAイベントを送信
 */
export const sendGuestCampaignPopupEvent = (value: {
  display_type: GuestCampaignDisplayType;
}) => {
  window.gtag('event', GA_EVENT_NAME.GUEST_CAMPAIGN, value);
};

/**
 * 広告タグ関連のイベント送信が有効な環境かどうかを判定する。
 * Dev環境（REACT_APP_API_MOCKING=true）では広告タグの発火を抑止する。
 */
const isAdTrackingEnabled = (): boolean =>
  process.env.REACT_APP_API_MOCKING !== 'true';

/**
 * 初回ログイン コンバージョンイベントを送信
 */
export const sendFirstLoginConversionEvent = (adParams?: AdParams | null) => {
  // Dev環境では広告タグを発火しない
  if (!isAdTrackingEnabled()) {
    return;
  }

  // GTM dataLayer にもイベントを送信
  window.dataLayer = window.dataLayer || [];

  const dlData: Record<string, string> = {
    event: GA_EVENT_NAME.FIRST_LOGIN,
    ad_source: adParams?.utm_source || 'organic',
    utm_source: adParams?.utm_source || '',
    utm_medium: adParams?.utm_medium || '',
    utm_campaign: adParams?.utm_campaign || '',
    utm_term: adParams?.utm_term || '',
    utm_content: adParams?.utm_content || '',
  };
  window.dataLayer.push(dlData);

  // GA4 にも直接送信
  // ※ GTM 側では first_login イベントに対する GA4 イベントタグを設定しないこと。
  //   GTM の first_login トリガーは広告コンバージョンタグ（Google Ads 等）専用。
  if (typeof window.gtag === 'function') {
    window.gtag('event', GA_EVENT_NAME.FIRST_LOGIN, {
      ad_source: adParams?.utm_source || 'organic',
    });
  }
};
